import React from "react";
import { useHistory } from "react-router-dom";
import { useCreateTimetable } from "frontend/src/domain/timetables/actions";
import { paths } from "frontend/src/pages/paths/index";
export var useCreateNewTimetable = function () {
    var history = useHistory();
    var _a = useCreateTimetable(), isLoading = _a.isLoading, data = _a.data, run = _a.run, isSuccess = _a.isSuccess;
    React.useEffect(function () {
        if (isSuccess && data) {
            history.push(paths.business.owner.timetables.edit(data.id));
        }
    }, [isSuccess]);
    return {
        createTimetable: function () { return run({ title: "Новая сетка вещания", entries: [] }); },
        isLoading: isLoading,
    };
};
